/** Map a raw catalog license type to its display word. */
export function licenseTypeLabel(licenseType: string): string {
  const labels: Record<string, string> = {
    fixed_seat: 'named',
    floating: 'floating',
  };
  return labels[licenseType] ?? licenseType;
}

/** Turn a catalog billing period into the price-note cadence word. */
export function billingCadence(billingPeriod: string): string {
  const period = billingPeriod.toLowerCase();
  if (period.includes('three') && period.includes('year'))
    return 'every 3 years';
  if (period.includes('year') || period.includes('annual')) return 'annually';
  if (period.includes('month')) return 'monthly';
  return billingPeriod || 'annually';
}
